export const personalInfo = {
  name: "Akshay Rao",
  title: "IT Support & Implementation Specialist",
  tagline: "Building the infrastructure that keeps business running.",
  email: "enquiries@akshayrao.com.au",
  emailFallback: "akshayraoisme@gmail.com",
  phone: "+61 452 340 963",
  location: "Melbourne, Australia",
  github: "https://github.com/akshayrao1",
  linkedin: "https://linkedin.com/in/akshayrao",
  availability: "Available for new projects",
}

export const careerPhases = [
  {
    id: 1,
    phase: "01",
    city: "Pune",
    country: "India",
    flag: "IN",
    years: "2019 — 2022",
    tagline: "Building IT support foundations.",
    color: "#00D4FF",
    svgX: 205,
    svgY: 169,
    roles: [
      {
        title: "IT Technical Support Specialist",
        company: "Amazon Development Center",
        period: "Nov 2019 — Mar 2021",
        highlights: [
          "Hardware/software diagnostics at enterprise scale",
          "TCP/IP network troubleshooting",
          "High-volume customer query management"
        ]
      },
      {
        title: "IT Technical Support Specialist",
        company: "TechMahindra",
        period: "Apr 2021 — May 2022",
        highlights: [
          "Security protocol implementation",
          "Call log analysis & trend identification",
          "Fault diagnosis frameworks"
        ]
      }
    ]
  },
  {
    id: 2,
    phase: "02",
    city: "Kuwait City",
    country: "Kuwait",
    flag: "KW",
    years: "2022 — 2024",
    tagline: "Critical national infrastructure.",
    color: "#00D4FF",
    svgX: 436,
    svgY: 234,
    roles: [
      {
        title: "Data Center Administrator",
        company: "Bahman General Trading",
        period: "Jun 2022 — Apr 2023",
        highlights: [
          "Organization-wide technical support",
          "Hardware & software system maintenance",
          "Performance optimization protocols"
        ]
      },
      {
        title: "Resident Engineer — CBK Data Center",
        company: "Khorafi Business Machines",
        period: "May 2023 — 2024",
        highlights: [
          "Central Bank of Kuwait system reliability",
          "24/7 on-call rapid response",
          "SLA-based server deployment"
        ]
      }
    ]
  },
  {
    id: 3,
    phase: "03",
    city: "Melbourne",
    country: "Australia",
    flag: "AU",
    years: "2024 — Now",
    tagline: "Implementation + software development.",
    color: "#00D4FF",
    svgX: 749,
    svgY: 345,
    roles: [
      {
        title: "IT Implementation Specialist",
        company: "Independent",
        period: "2024 — Present",
        highlights: [
          "Full-stack store IT delivery (CCTV to POS)",
          "Multi-store operations across 4 locations",
          "POS + ordering app development"
        ]
      },
      {
        title: "Masters — Applied IT",
        company: "Victoria University",
        period: "2024 — Present",
        highlights: [
          "Advanced IT Systems",
          "Applied software engineering",
          "Research in implementation"
        ]
      }
    ]
  }
]

export const wins = [
  "B.TECH INFORMATION TECHNOLOGY — AJEENKYA DY PATIL",
  "CENTRAL BANK OF KUWAIT — DATA CENTER ENGINEER",
  "VICTORIA UNIVERSITY — MASTERS APPLIED IT",
  "DELL EMC PYTHON ASSOCIATE CERTIFIED",
  "AMAZON DEVELOPMENT CENTER — PUNE",
  "TECHMAHINDRA — IT SPECIALIST",
  "MAJNU APP — LIVE & SERVING CUSTOMERS",
  "4 STORES MANAGED SIMULTANEOUSLY",
  "MELBOURNE · KUWAIT CITY · PUNE",
]

export const skills = [
  {
    category: "IT Infrastructure",
    icon: "Server",
    accent: "#00D4FF",
    items: ["CCTV Systems", "Security Alarms", "PA & Audio Systems", "Structured Data Cabling", "POS Systems", "Email Hosting", "Network Setup"]
  },
  {
    category: "Systems & Data Centers",
    icon: "Database",
    accent: "#00D4FF",
    items: ["Central Bank of Kuwait DC", "Server Installation", "System Reliability", "Database Operations", "24/7 On-Call", "SLA Management"]
  },
  {
    category: "Software Development",
    icon: "Code2",
    accent: "#00D4FF",
    items: ["POS Application Dev", "CRM System Build", "HRMS Development", "React + FastAPI", "MongoDB", "Python (Dell EMC Certified)"]
  },
  {
    category: "Support & Networks",
    icon: "Headphones",
    accent: "#00D4FF",
    items: ["Hardware/Software Diagnostics", "TCP/IP Networking", "Security Protocols", "Helpdesk Management", "Log Analysis", "User Training"]
  }
]
